import React from 'react';

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function Inline(props) {
  var children = props.children;
  var childCount = React.Children.toArray(children).length;
  if (!childCount) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0");
  }
  return children;
}